import "./index.moduleRenamed.css";

export const schemaTree = "index-module__schemaTree___KSA-T";
export const noChild = "index-module__noChild___nmwjF";
export const objIdCode = "index-module__objIdCode___5T3-H";
export const comment = "index-module__comment___Zdo3U";
export const objTypeCode = "index-module__objTypeCode___U1JZv";
export const overflowDetect = "index-module__overflowDetect___hMQDJ";
export const rootTitle = "index-module__rootTitle___q-szh";
export const hideTooltip = "index-module__hideTooltip___Oigyl";

export default {
  schemaTree: "index-module__schemaTree___KSA-T",
  noChild: "index-module__noChild___nmwjF",
  objIdCode: "index-module__objIdCode___5T3-H",
  comment: "index-module__comment___Zdo3U",
  objTypeCode: "index-module__objTypeCode___U1JZv",
  overflowDetect: "index-module__overflowDetect___hMQDJ",
  rootTitle: "index-module__rootTitle___q-szh",
  hideTooltip: "index-module__hideTooltip___Oigyl",
};